<template>
  <b-sidebar id="edit-location-sidebar" :visible="isEditLocationSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-edit-location-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Edit Location
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">

          <!-- Locationname -->
          <validation-provider #default="validationContext" name="Location Name" rules="required">
            <b-form-group label="Location Name" label-for="locationname">
              <b-form-input id="locationname" v-model="locationData.locationname"
                :state="getValidationState(validationContext)" trim/>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Country -->
          <validation-provider #default="validationContext" name="Country" rules="required">
            <b-form-group label="Country" label-for="country" :state="getValidationState(validationContext)">
              <v-select v-model="locationData.country" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="countries" :clearable="false" input-id="country" />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
              Save
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
              @click="hide">
              Cancel
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, watch, getCurrentInstance } from '@vue/composition-api'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditLocationSidebarActive',
    event: 'update:is-edit-location-sidebar-active',
  },
  props: {
    isEditLocationSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
    item: {
      required: true,
    }
  },
  data() {
    return {
      required,
      alphaNum,
      countries,
    }
  },
  setup(props, { emit }) {
    const blankLocationData = ref({
      locationname: '',
      country: '',
    })

    const locationData = ref({ ...blankLocationData.value })

    const resetLocationData = () => {
      locationData.value = { ...blankLocationData.value }
    }

    // Watch for changes to the sidebar active state
    watch(() => props.isEditLocationSidebarActive, (newVal) => {
      if (newVal && props.item) {
        // Populate the form fields when the sidebar is opened
        locationData.value.locationname = props.item.name.split(',')[0].trim()
        locationData.value.country = props.item.name.split(',')[1].trim()
      } 
      // else {
      //   resetLocationData()
      // }
    }, { immediate: true })

    const { proxy } = getCurrentInstance()

    const onSubmit = () => {
      const location = `${locationData.value.locationname}, ${locationData.value.country}`
      console.log(location)
      store.dispatch('app-location/editLocation', { id: props.item._id, name: location })
      .then(() => {
          emit('refetch-data')
          emit('update:is-edit-location-sidebar-active', false)
          proxy.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Location Saved Successfully!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch((err) => {
          const errorMessage = (err.response && err.response.data && err.response.data.error) || 'Something went wrong.'
          proxy.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              text: errorMessage,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetLocationData)

    return {
      locationData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#edit-location-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
